import styled from 'styled-components';

export const Wrapper = styled.aside`
  display: flex;
  grid-area: sidebar;
  flex-direction: column;
  min-height: 100%;
  padding-top: ${({ theme }) => theme.spacings.abs32}px;
  overflow: visible;
  height: 100vh;
`;

export const Bottom = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  justify-content: flex-end;
  margin-top: ${({ theme }) => theme.spacings.abs24}px;
`;

export const BottomLine = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

export const ScrollView = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow-y: auto;
  padding-bottom: ${({ theme }) => theme.spacings.abs24}px;

  ::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
`;
